import axios from './HTTP'

export default {
  create (params, callback, errorCallback) {
    axios
      .post('/api/employee_watch_lists.json', {
        name: params.name
      })
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  destroy (params, callback, errorCallback) {
    axios
      .delete(`/api/employee_watch_lists/${ params.listID }.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  getAll (callback) {
    axios
      .get('/api/employee_watch_lists.json')
      .then(response => ( callback(response.data) ))
  },

  getList (id, callback, errorCallback) {
    axios
      .get(`/api/employee_watch_lists/${ id }.json`)
      .then(response => ( callback(response.data) ))
      .catch(error => ( errorCallback(error) ))
  },

  addEmployeeIDsToList (params, callback, errorCallback) {
    axios
      .patch(`/api/employee_watch_lists/${ params.listID }/add_employees.json`, {
        employeeIDs: params.employeeIDs
      })
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  },

  removeEmployeeIDsFromList (params, callback, errorCallback) {
    axios
      .patch(`/api/employee_watch_lists/${ params.listID }/remove_employees.json`, {
        employeeIDs: params.employeeIDs
      })
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  }
}
